/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBCOMMODITY = 'GETCLUBCOMMODITY'
export const GETQINIUTOKEN = 'GETQINIUTOKEN'
export const GETIMAGEURL = 'GETIMAGEURL'
export const GETINSTORAGE = 'GETINSTORAGE'
export const GETCOMMODITYTOTAL = 'GETCOMMODITYTOTAL'
export const GETCLUBCOMMODITYOUT = 'GETCLUBCOMMODITYOUT'




// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/constants.js